import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class MentionFormat {
  constructor() {
    _defineProperty(this, "instances", void 0);
    _defineProperty(this, "mentionables", void 0);
    _defineProperty(this, "extendable", void 0);
  }
  makeMentionables() {
    var _this$instances;
    return (_this$instances = this.instances) != null ? _this$instances : this.instances = this.mentionables.map(Mentionable => new Mentionable(this));
  }
  getMentionable(type) {
    var _this$makeMentionable;
    return (_this$makeMentionable = this.makeMentionables().find(mentionable => mentionable.type() === type)) != null ? _this$makeMentionable : null;
  }
  extend(mentionable) {
    if (!this.extendable) throw new Error('This mention format does not allow extending.');
    this.mentionables.push(mentionable);
  }

  /**
   * Picks the term to search in the API from the typed text.
   * @example:
   *  * Full text = `Hello @"John D`
   *  * Typed text = `"John D`
   *  * Query = `John D`
   */
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/MentionFormat', MentionFormat);